import { SignatureRequestStatus, UserAction } from '../constants';
import { SignerStatus } from '../data/rsTypes';

interface Signer {
	id: string;
	email: string;
	status: string;
	[key: string]: unknown; // allows additional properties
}
export const getSigner = (userEmail: string, signers?: Signer[]) => {
	if (signers === null) {
		return null;
	}

	const matchingSigner = signers?.find(
		(signer: Signer) => signer?.email.toLowerCase() === userEmail.toLowerCase()
	);
	return matchingSigner;
};

export const findUserAction = (
	signatureRequestStatus: string,
	signer?: Signer | null
) => {
	if (!signer || !signatureRequestStatus) {
		return UserAction.Unknown;
	}

	switch (signatureRequestStatus) {
		case SignatureRequestStatus.Pending:
			switch (signer.status) {
				case SignerStatus.Pending:
					return UserAction.PendingSignature;
				default:
					return UserAction.Completed;
			}

		case SignatureRequestStatus.Executed:
		case SignatureRequestStatus.Declined:
		case SignatureRequestStatus.Voided:
		case SignatureRequestStatus.Expired:
			return UserAction.Completed;

		default:
			return UserAction.Unknown;
	}
};
